import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Dropdown, Menu, Avatar } from "antd";
import {
  UserOutlined,
  DownOutlined,
  KeyOutlined,
  SettingOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import { NavLink } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { getUserProfile } from "../redux/AuthController";

const UserDropdown = ({ userAuth, setShowModal }) => {
  const profileUser = useSelector((state) => state.profile.userData);
  const [fetchedAvatarUrl, setFetchedAvatarUrl] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    let cancelled = false;
    const fetchUserProfile = async () => {
      try {
        const res = await dispatch(getUserProfile());
        if (cancelled || !res.payload) return;
        const data = res.payload?.obj ?? res.payload;
        const url = data?.profile || data?.picture;
        if (url) setFetchedAvatarUrl(url);
      } catch {
        /* ignore */
      }
    };
    fetchUserProfile();
    return () => {
      cancelled = true;
    };
  }, [dispatch]);

  const avatarSrc = useMemo(
    () =>
      profileUser?.profile ||
      profileUser?.picture ||
      fetchedAvatarUrl ||
      userAuth?.obj?.profile ||
      userAuth?.obj?.picture ||
      undefined,
    [
      profileUser?.profile,
      profileUser?.picture,
      fetchedAvatarUrl,
      userAuth?.obj?.profile,
      userAuth?.obj?.picture,
    ],
  );

  const firstName =
    profileUser?.firstName || userAuth?.obj?.firstName || "User";
  const lastName = profileUser?.lastName || userAuth?.obj?.lastName || "";

  const handleLogout = async () => {
  
    setShowModal(true);
  };

  const menu = (
    <Menu>
      <Menu.Item key="profile" icon={<UserOutlined />}>
        <NavLink to="/profile">Profile</NavLink>
      </Menu.Item>
      <Menu.Item key="update-password" icon={<KeyOutlined />}>
        <NavLink to="/update-password">Update Password</NavLink>
      </Menu.Item>
      <Menu.Item key="settings" icon={<SettingOutlined />}>
        <NavLink to="/settings">Settings</NavLink>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={handleLogout}>
        <button
          style={{
            border: "none",
            background: "none",
            padding: 0,
            margin: 0,
            cursor: "pointer",
          }}
        >
          Logout
        </button>
      </Menu.Item>
    </Menu>
  );
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <Dropdown overlay={menu} trigger={["click"]}>
      <div
        onClick={(e) => e.preventDefault()}
        style={{ display: "flex", alignItems: "center"}}
      >
        <Avatar
          src={avatarSrc}
          alt={firstName}
          icon={<UserOutlined />}
          size={42}
          style={{ marginRight: 8 }}
        />
        {isMobile?"":
        <span style={{ marginRight: 8, color: "#595959", fontSize: "14px" }}>
          {firstName} {lastName}
        </span>}
        <DownOutlined style={{ color: "#595959", fontSize: "12px" }} />
      </div>
    </Dropdown>
  );
};

export default UserDropdown;
